import { ChakraProvider as e, extendTheme as ee, theme as t } from "@chakra-ui/react";
import { jsx as n } from "react/jsx-runtime";
//#region \0rolldown/runtime.js
var te = Object.defineProperty, ne = (e, ee) => {
	let t = {};
	for (var n in e) te(t, n, {
		get: e[n],
		enumerable: !0
	});
	return ee || te(t, Symbol.toStringTag, { value: "Module" }), t;
}, re = /* @__PURE__ */ ne({
	BackgroundColoursCtaBackgroundColour: () => Gt,
	BackgroundColoursError: () => Xt,
	BackgroundColoursHighlight: () => Zt,
	BackgroundColoursInformative: () => Jt,
	BackgroundColoursNeutral: () => qt,
	BackgroundColoursSuccess: () => Kt,
	BackgroundColoursWarning: () => Yt,
	BadgeMdContainerError: () => un,
	BadgeMdContainerHighlight: () => dn,
	BadgeMdContainerInfo: () => cn,
	BadgeMdContainerNeutral: () => sn,
	BadgeMdContainerSuccess: () => on,
	BadgeMdContainerWarning: () => ln,
	BadgeSmContainerError: () => gn,
	BadgeSmContainerHighlight: () => _n,
	BadgeSmContainerInfo: () => mn,
	BadgeSmContainerNeutral: () => pn,
	BadgeSmContainerSuccess: () => fn,
	BadgeSmContainerWarning: () => hn,
	BadgeTextLabelError: () => Sn,
	BadgeTextLabelHighlight: () => Cn,
	BadgeTextLabelInfo: () => bn,
	BadgeTextLabelNeutral: () => yn,
	BadgeTextLabelSuccess: () => vn,
	BadgeTextLabelWarning: () => xn,
	BorderRadius4: () => "4px",
	BorderRadius6: () => "6px",
	BorderRadius8: () => "8px",
	FontFamiliesInconsolata: () => zt,
	FontFamiliesLato: () => Rt,
	FontFamiliesModerat: () => Bt,
	FontFamiliesSystem: () => J,
	FontSize12: () => he,
	FontSize13: () => ge,
	FontSize14: () => _e,
	FontSize16: () => ve,
	FontSize18: () => ye,
	FontSize20: () => be,
	FontSize24: () => xe,
	FontSize28: () => Se,
	FontSize32: () => Ce,
	FontSize40: () => we,
	FontWeightsBold: () => 700,
	FontWeightsRegular: () => 400,
	FontWeightsSemiBold: () => 600,
	GreenGreen10: () => Ee,
	GreenGreen20: () => h,
	GreenGreen30: () => De,
	GreenGreen40: () => Oe,
	GreenGreen50: () => ke,
	GreenGreen60: () => g,
	GreenGreen70: () => Ae,
	GreenGreen80: () => je,
	GreenGreen90: () => Me,
	GreyGrey0: () => i,
	GreyGrey10: () => a,
	GreyGrey100: () => m,
	GreyGrey20: () => o,
	GreyGrey30: () => s,
	GreyGrey40: () => c,
	GreyGrey50: () => l,
	GreyGrey60: () => u,
	GreyGrey70: () => d,
	GreyGrey80: () => f,
	GreyGrey90: () => p,
	GreyWhite: () => r,
	IndigoIndigo10: () => Ne,
	IndigoIndigo20: () => Pe,
	IndigoIndigo30: () => Fe,
	IndigoIndigo40: () => E,
	IndigoIndigo50: () => D,
	IndigoIndigo60: () => O,
	IndigoIndigo70: () => Ie,
	IndigoIndigo80: () => Le,
	IndigoIndigo90: () => Re,
	Lato12Bold: () => Pt,
	Lato12Regular: () => Ft,
	Lato16Bold: () => It,
	Lato24Bold: () => Lt,
	LetterSpacingSm: () => Zn,
	LineHeights16: () => ie,
	LineHeights20: () => ae,
	LineHeights24: () => oe,
	LineHeights28: () => se,
	LineHeights32: () => ce,
	LineHeights40: () => le,
	LineHeights48: () => ue,
	LineHeights64: () => de,
	MonoSpaced12SemiBold: () => tr,
	MonoSpaced13SemiBold: () => er,
	MonoSpaced20Regular: () => $n,
	OnBackgroundColoursError: () => rn,
	OnBackgroundColoursHighlight: () => an,
	OnBackgroundColoursInformative: () => tn,
	OnBackgroundColoursMainDark: () => Qt,
	OnBackgroundColoursMainLight: () => Q,
	OnBackgroundColoursNeutral: () => en,
	OnBackgroundColoursSuccess: () => $t,
	OnBackgroundColoursWarning: () => nn,
	OrangeOrange10: () => Je,
	OrangeOrange20: () => Ye,
	OrangeOrange30: () => Xe,
	OrangeOrange40: () => Ze,
	OrangeOrange50: () => Qe,
	OrangeOrange60: () => $e,
	OrangeOrange70: () => et,
	OrangeOrange80: () => tt,
	OrangeOrange90: () => nt,
	Primary12Regular: () => U,
	Primary12SemiBold: () => gt,
	Primary12UppercaseRegular: () => vt,
	Primary12UppercaseSemiBold: () => _t,
	Primary13Regular: () => q,
	Primary13SemiBold: () => K,
	Primary14ExtendedRegular: () => Nt,
	Primary14ExtendedSemiBold: () => Mt,
	Primary14SemiBold: () => G,
	Primary16Regular: () => jt,
	Primary16SemiBold: () => W,
	Primary18Regular: () => At,
	Primary18SemiBold: () => kt,
	Primary20Regular: () => Ot,
	Primary20SemiBold: () => Dt,
	Primary24Regular: () => Et,
	Primary24SemiBold: () => Tt,
	Primary28Regular: () => wt,
	Primary28SemiBold: () => Ct,
	Primary32Regular: () => St,
	Primary32SemiBold: () => xt,
	Primary40Regular: () => bt,
	Primary40SemiBold: () => yt,
	PrimaryHeader32Regular: () => Te,
	PrimaryPrimary10: () => dt,
	PrimaryPrimary20: () => ft,
	PrimaryPrimary30: () => pt,
	PrimaryPrimary40: () => mt,
	PrimaryPrimary50: () => ht,
	PrimaryPrimary60: () => z,
	PrimaryPrimary70: () => B,
	PrimaryPrimary80: () => V,
	PrimaryPrimary90: () => H,
	PurplePurple10: () => ze,
	PurplePurple20: () => Be,
	PurplePurple30: () => Ve,
	PurplePurple40: () => He,
	PurplePurple50: () => Ue,
	PurplePurple60: () => We,
	PurplePurple70: () => Ge,
	PurplePurple80: () => Ke,
	PurplePurple90: () => qe,
	RedRed10: () => k,
	RedRed20: () => A,
	RedRed30: () => j,
	RedRed40: () => M,
	RedRed50: () => N,
	RedRed60: () => P,
	RedRed70: () => F,
	RedRed80: () => I,
	RedRed90: () => L,
	Shadow1: () => Ht,
	ShadowColourGrey100: () => Vt,
	ShadowL: () => Wt,
	ShadowM: () => Ut,
	ShadowS: () => X,
	ShadowSEmboss: () => Z,
	ShadowXs: () => Y,
	Sizing12: () => Bn,
	Sizing16: () => Vn,
	Sizing18: () => Hn,
	Sizing20: () => Un,
	Sizing24: () => Wn,
	Sizing32: () => Gn,
	Sizing40: () => Kn,
	Sizing48: () => qn,
	Sizing56: () => Jn,
	Sizing72: () => Yn,
	Sizing8: () => "8px",
	Sizing80: () => Xn,
	Spacing12: () => En,
	Spacing16: () => Dn,
	Spacing20: () => On,
	Spacing24: () => kn,
	Spacing32: () => An,
	Spacing4: () => "4px",
	Spacing40: () => jn,
	Spacing48: () => Mn,
	Spacing56: () => Nn,
	Spacing72: () => Pn,
	Spacing8: () => "8px",
	Spacing80: () => Fn,
	TextCaseUppercase: () => Qn,
	TokenSetOrder0: () => nr,
	TurquoiseTurquoise10: () => _,
	TurquoiseTurquoise20: () => v,
	TurquoiseTurquoise30: () => y,
	TurquoiseTurquoise40: () => b,
	TurquoiseTurquoise50: () => x,
	TurquoiseTurquoise60: () => S,
	TurquoiseTurquoise70: () => C,
	TurquoiseTurquoise80: () => w,
	TurquoiseTurquoise90: () => T,
	YellowYellow10: () => rt,
	YellowYellow20: () => it,
	YellowYellow30: () => at,
	YellowYellow40: () => ot,
	YellowYellow50: () => st,
	YellowYellow60: () => ct,
	YellowYellow70: () => lt,
	YellowYellow80: () => ut,
	YellowYellow90: () => R
}), ie = "16px", ae = "20px", oe = "24px", se = "28px", ce = "32px", le = "40px", ue = "48px", de = "64px", fe = 400, pe = 600, me = 700, he = "12px", ge = "13px", _e = "14px", ve = "16px", ye = "18px", be = "20px", xe = "24px", Se = "28px", Ce = "32px", we = "40px", Te = {
	fontFamily: "Moderat Serif",
	fontWeight: 400,
	lineHeight: 1.2,
	fontSize: "32px",
	letterSpacing: "-0.5px"
}, r = "#ffffff", i = "#fbfcfe", a = "#f8fafc", o = "#f1f5f9", s = "#e2e8f0", c = "#cbd5e1", l = "#94a3b8", u = "#64748b", d = "#475569", f = "#334155", p = "#1e293b", m = "#0f172a", Ee = "#dcfce7", h = "#bbf7d0", De = "#86efac", Oe = "#4ade80", ke = "#22c55e", g = "#16a34a", Ae = "#15803d", je = "#166534", Me = "#14532d", _ = "#ccfbf1", v = "#99f6e4", y = "#5eead4", b = "#2dd4bf", x = "#14b8a6", S = "#0d9488", C = "#0f766e", w = "#115e59", T = "#134e4a", Ne = "#e0e7ff", Pe = "#c7d2fe", Fe = "#a5b4fc", E = "#818cf8", D = "#6366f1", O = "#4f46e5", Ie = "#4338ca", Le = "#3730a3", Re = "#312e81", ze = "#f3e8ff", Be = "#e9d5ff", Ve = "#d8b4fe", He = "#c084fc", Ue = "#a855f7", We = "#9333ea", Ge = "#7e22ce", Ke = "#6b21a8", qe = "#581c87", k = "#fee2e2", A = "#fecaca", j = "#fca5a5", M = "#f87171", N = "#ef4444", P = "#dc2626", F = "#b91c1c", I = "#991b1b", L = "#7f1d1d", Je = "#ffedd5", Ye = "#fed7aa", Xe = "#fdba74", Ze = "#fb923c", Qe = "#f97316", $e = "#ea580c", et = "#c2410c", tt = "#9a3412", nt = "#7c2d12", rt = "#fef3c7", it = "#fde68a", at = "#fcd34d", ot = "#fbbf24", st = "#f59e0b", ct = "#d97706", lt = "#b45309", ut = "#92400e", R = "#78350f", dt = _, ft = v, pt = y, mt = b, ht = x, z = S, B = C, V = w, H = T, gt = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 600,
	lineHeight: "16px",
	fontSize: "12px",
	letterSpacing: "0px"
}, _t = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 600,
	lineHeight: "16px",
	fontSize: "12px",
	letterSpacing: "0px",
	textTransform: "uppercase"
}, U = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 400,
	lineHeight: "16px",
	fontSize: "12px",
	letterSpacing: "0px"
}, vt = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 400,
	lineHeight: "16px",
	fontSize: "12px",
	textTransform: "uppercase",
	letterSpacing: "0px"
}, yt = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 600,
	lineHeight: "64px",
	fontSize: "40px",
	letterSpacing: "0.4px"
}, bt = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 400,
	lineHeight: "64px",
	fontSize: "40px",
	letterSpacing: "0.4px"
}, xt = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 600,
	lineHeight: "40px",
	fontSize: "32px",
	letterSpacing: "0.42px"
}, St = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 400,
	lineHeight: "40px",
	fontSize: "32px",
	letterSpacing: "0.42px"
}, Ct = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 600,
	lineHeight: "32px",
	fontSize: "28px",
	letterSpacing: "0.39px"
}, wt = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 400,
	lineHeight: "32px",
	fontSize: "28px",
	letterSpacing: "0.39px"
}, Tt = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 600,
	lineHeight: "28px",
	fontSize: "24px",
	letterSpacing: "0.07px"
}, Et = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 400,
	lineHeight: "28px",
	fontSize: "24px",
	letterSpacing: "0.07px"
}, Dt = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 600,
	lineHeight: "24px",
	fontSize: "20px",
	letterSpacing: "-0.46px"
}, Ot = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 400,
	lineHeight: "24px",
	fontSize: "20px",
	letterSpacing: "-0.46px"
}, kt = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 600,
	lineHeight: "24px",
	fontSize: "18px",
	letterSpacing: "-0.45px"
}, At = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 400,
	lineHeight: "24px",
	fontSize: "18px",
	letterSpacing: "-0.45px"
}, W = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 600,
	lineHeight: "24px",
	fontSize: "16px",
	letterSpacing: "0px"
}, jt = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 400,
	lineHeight: "24px",
	fontSize: "16px",
	letterSpacing: "0px"
}, Mt = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 600,
	lineHeight: "20px",
	fontSize: "14px",
	letterSpacing: "-0.15px"
}, Nt = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 400,
	lineHeight: "20px",
	fontSize: "14px",
	letterSpacing: "-0.15px"
}, G = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 600,
	lineHeight: "16px",
	fontSize: "14px",
	letterSpacing: "-0.15px"
}, K = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 600,
	lineHeight: "16px",
	fontSize: "13px",
	letterSpacing: "-0.08px"
}, q = {
	fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
	fontWeight: 400,
	lineHeight: "16px",
	fontSize: "13px",
	letterSpacing: "-0.08px"
}, Pt = {
	fontFamily: "Lato",
	fontWeight: 700,
	lineHeight: "16px",
	fontSize: "12px"
}, Ft = {
	fontFamily: "Lato",
	fontWeight: 400,
	lineHeight: "16px",
	fontSize: "12px"
}, It = {
	fontFamily: "Lato",
	fontWeight: 700,
	lineHeight: "24px",
	fontSize: "16px"
}, Lt = {
	fontFamily: "Lato",
	fontWeight: 700,
	lineHeight: "28px",
	fontSize: "24px"
}, Rt = "Lato", J = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif", zt = "ui-monospace, 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, Inconsolata, 'Courier New', monospace", Bt = "Moderat Serif", Vt = m, Ht = "0 2px 4px 0 0F172A08", Y = "0 0 2px 0 #00000005, 0 1px 1px 0 #0000000d", X = "0 1px 3px 0 #00000014, 0 0 5px 0 #00000008", Z = "0 1px 3px 0 #00000014, 0 0 5px 0 #00000008, inset 0 -1px 1px 0 #00000012", Ut = "0 4px 8px 0 #0000000a, 0 0 4px 0 #00000005", Wt = "0 8px 16px 0 #0000000d, 0 0 4px 0 #00000005", Gt = "#003337", Kt = "#ebfbc9", qt = "#f1f4f8", Jt = "#dedaff", Yt = "#ffe6a8", Xt = "#ffccd5", Zt = "#ffccff", Qt = "#14171c", Q = "#fcfcfd", $t = "#1b6600", en = "#344054", tn = "#26137d", nn = "#63470f", rn = "#a1001d", an = "#501e5e", on = {
	fill: "#ebfbc9",
	borderRadius: "4px",
	height: "24px",
	verticalPadding: "4px",
	horizontalPadding: "8px"
}, sn = {
	fill: "#f1f4f8",
	borderRadius: "4px",
	height: "24px",
	verticalPadding: "4px",
	horizontalPadding: "8px"
}, cn = {
	fill: "#dedaff",
	borderRadius: "4px",
	height: "24px",
	verticalPadding: "4px",
	horizontalPadding: "8px"
}, ln = {
	fill: "#ffe6a8",
	borderRadius: "4px",
	height: "24px",
	verticalPadding: "4px",
	horizontalPadding: "8px"
}, un = {
	fill: "#ffccd5",
	borderRadius: "4px",
	height: "24px",
	verticalPadding: "4px",
	horizontalPadding: "8px"
}, dn = {
	fill: "#ffccff",
	borderRadius: "4px",
	height: "24px",
	verticalPadding: "4px",
	horizontalPadding: "8px"
}, fn = {
	fill: "#ebfbc9",
	borderRadius: "4px",
	height: "20px",
	horizontalPadding: "4px"
}, pn = {
	fill: "#f1f4f8",
	borderRadius: "4px",
	height: "20px",
	horizontalPadding: "4px"
}, mn = {
	fill: "#dedaff",
	borderRadius: "4px",
	height: "20px",
	horizontalPadding: "4px"
}, hn = {
	fill: "#ffe6a8",
	borderRadius: "4px",
	height: "20px",
	horizontalPadding: "4px"
}, gn = {
	fill: "#ffccd5",
	borderRadius: "4px",
	height: "20px",
	horizontalPadding: "4px"
}, _n = {
	fill: "#ffccff",
	borderRadius: "4px",
	height: "20px",
	horizontalPadding: "4px"
}, vn = {
	typography: {
		fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
		fontWeight: 400,
		lineHeight: "16px",
		fontSize: "12px",
		letterSpacing: "0px"
	},
	fill: "#1b6600"
}, yn = {
	typography: {
		fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
		fontWeight: 400,
		lineHeight: "16px",
		fontSize: "12px",
		letterSpacing: "0px"
	},
	fill: "#344054"
}, bn = {
	typography: {
		fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
		fontWeight: 400,
		lineHeight: "16px",
		fontSize: "12px",
		letterSpacing: "0px"
	},
	fill: "#26137d"
}, xn = {
	typography: {
		fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
		fontWeight: 400,
		lineHeight: "16px",
		fontSize: "12px",
		letterSpacing: "0px"
	},
	fill: "#63470f"
}, Sn = {
	typography: {
		fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
		fontWeight: 400,
		lineHeight: "16px",
		fontSize: "12px",
		letterSpacing: "0px"
	},
	fill: "#a1001d"
}, Cn = {
	typography: {
		fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
		fontWeight: 400,
		lineHeight: "16px",
		fontSize: "12px",
		letterSpacing: "0px"
	},
	fill: "#501e5e"
}, wn = "4px", Tn = "8px", En = "12px", Dn = "16px", On = "20px", kn = "24px", An = "32px", jn = "40px", Mn = "48px", Nn = "56px", Pn = "72px", Fn = "80px", In = "4px", Ln = "6px", Rn = "8px", zn = "8px", Bn = "12px", Vn = "16px", Hn = "18px", Un = "20px", Wn = "24px", Gn = "32px", Kn = "40px", qn = "48px", Jn = "56px", Yn = "72px", Xn = "80px", Zn = "0.12px", Qn = "uppercase", $n = {
	fontFamily: "ui-monospace, 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, Inconsolata, 'Courier New', monospace",
	fontWeight: 400,
	fontSize: "20px",
	lineHeight: "24px"
}, er = {
	fontFamily: "ui-monospace, 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, Inconsolata, 'Courier New', monospace",
	fontWeight: 600,
	fontSize: "13px",
	lineHeight: "16px"
}, tr = {
	fontFamily: "ui-monospace, 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, Inconsolata, 'Courier New', monospace",
	fontWeight: 600,
	fontSize: "12px",
	lineHeight: "16px"
}, nr = "Sequence Tokens", rr = `0 0 0 1px ${D}`, ir = `0 0 0 1px ${P}`, $ = c, ar = s, or = "6px", sr = `1px solid ${$}`, cr = `1px solid ${ar}`, lr = o, ur = {
	gray: {
		0: i,
		10: a,
		20: o,
		30: s,
		40: c,
		50: l,
		60: u,
		70: d,
		80: f,
		90: p,
		100: m
	},
	turquoise: {
		10: _,
		20: v,
		30: y,
		40: b,
		50: x,
		60: S,
		70: C,
		80: w,
		90: T
	},
	green: {
		10: Ee,
		20: h,
		30: De,
		40: Oe,
		50: ke,
		60: g,
		70: Ae,
		80: je,
		90: Me
	},
	indigo: {
		10: Ne,
		20: Pe,
		30: Fe,
		40: E,
		50: D,
		60: O,
		70: Ie,
		80: Le,
		90: Re
	},
	pink: {
		10: k,
		20: A,
		30: j,
		40: M,
		50: N,
		60: P,
		70: F,
		80: I,
		90: L
	},
	yellow: {
		10: rt,
		20: it,
		30: at,
		40: ot,
		50: st,
		60: ct,
		70: lt,
		80: ut,
		90: R
	},
	orange: {
		10: Je,
		20: Ye,
		30: Xe,
		40: Ze,
		50: Qe,
		60: $e,
		70: et,
		80: tt,
		90: nt
	},
	purple: {
		10: ze,
		20: Be,
		30: Ve,
		40: He,
		50: Ue,
		60: We,
		70: Ge,
		80: Ke,
		90: qe
	},
	red: {
		10: k,
		20: A,
		30: j,
		40: M,
		50: N,
		60: P,
		70: F,
		80: I,
		90: L
	},
	primary: {
		10: dt,
		20: ft,
		30: pt,
		40: mt,
		50: ht,
		60: z,
		70: B,
		80: V,
		90: H
	}
}, { Accordion: dr } = t.components, fr = {
	parts: [...dr.parts],
	variants: { templateModal: {
		button: {
			px: 0,
			py: "8px",
			_hover: { bg: "transparent" }
		},
		container: { border: "none" },
		panel: {
			py: 0,
			px: 0
		}
	} }
}, pr = "0px 0px 5px 0px rgba(0, 0, 0, 0.03), 0px 1px 3px 0px rgba(0, 0, 0, 0.08)", mr = `0 0 0 2px ${E}`, hr = {
	variants: {
		select: {
			borderColor: "blue.20",
			borderWidth: "1px",
			borderRadius: "18px",
			backgroundColor: "white",
			fontWeight: 400,
			fontSize: "14px",
			lineHeight: "24px",
			color: "blue.200",
			_placeholder: { color: "blue.40" },
			boxSizing: "content-box",
			height: "32px",
			type: "text"
		},
		round: {
			borderColor: "blue.20",
			borderWidth: "1px",
			borderRadius: "100%",
			backgroundColor: "white",
			fontWeight: 400,
			fontSize: "14px",
			lineHeight: "24px",
			color: "blue.200",
			_placeholder: { color: "blue.40" },
			boxSizing: "content-box",
			height: "32px",
			width: "32px",
			type: "text",
			padding: 0
		},
		primary: {
			...G,
			borderRadius: "20px",
			backgroundColor: H,
			color: Q,
			textTransform: "none",
			width: "fit-content",
			lineHeight: "16px",
			px: 6,
			py: 3,
			_hover: { bg: `${B}` },
			_active: { bg: V },
			_focus: { boxShadow: `0 0 0 2px ${z}` },
			_disabled: {
				opacity: .4,
				_hover: { bg: `${B}` }
			},
			_loading: { _hover: { bg: `${B}` } }
		},
		primary2: {
			...G,
			borderRadius: "8px",
			border: `2px solid ${V}`,
			backgroundColor: V,
			color: Q,
			boxShadow: "0px -1px 1px 0px rgba(0, 0, 0, 0.16) inset, 0px 0px 3px 0px rgba(0, 0, 0, 0.04), 0px 1px 2px 0px rgba(0, 0, 0, 0.12)",
			textTransform: "none",
			width: "fit-content",
			lineHeight: "16px",
			px: "8px",
			py: 0,
			pb: "2px",
			_hover: {
				bg: `${B}`,
				_disabled: { bg: `${B}` }
			},
			_active: { bg: V },
			_focus: {
				border: `2px solid ${z}`,
				backgroundColor: H,
				boxShadow: `0 0 0 1px ${z}`
			},
			_disabled: {
				opacity: .4,
				_hover: { bg: `${B}` }
			},
			_loading: { _hover: { bg: `${B}` } }
		},
		secondary: {
			...G,
			borderRadius: "20px",
			backgroundColor: r,
			color: H,
			border: `1px solid ${s}`,
			textTransform: "none",
			width: "fit-content",
			px: 6,
			py: 3,
			_hover: { bg: a },
			_active: { bg: c },
			_focus: {
				borderColor: "transparent",
				bg: r,
				boxShadow: `0 0 0 2px ${z}`
			},
			_disabled: { opacity: .4 }
		},
		secondary2: {
			...G,
			borderRadius: "8px",
			backgroundColor: r,
			color: H,
			border: `1px solid ${s}`,
			textTransform: "none",
			width: "fit-content",
			boxShadow: "0px 1px 3px 0px rgba(15, 23, 42, 0.08), 0px 0 5px 0px rgba(0, 0, 0, 0.03) inset",
			px: "12px",
			py: 0,
			_hover: { bg: a },
			_active: { bg: c },
			_focus: {
				borderColor: "transparent",
				bg: r,
				boxShadow: `0 0 0 2px ${z}`
			},
			_disabled: { opacity: .4 }
		},
		buttonGroup: {
			...G,
			borderRadius: "8px",
			backgroundColor: a,
			color: u,
			border: `1px solid ${s}`,
			boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.02)",
			textTransform: "none",
			width: "fit-content",
			p: "12px",
			_notLast: { borderRight: "none" },
			_active: {
				bg: r,
				color: O
			},
			_disabled: { opacity: .4 }
		},
		"component-library-button-group": {
			...K,
			height: "initial",
			minWidth: "initial",
			padding: "6px 10px",
			color: d,
			transition: "color 125ms ease-in-out",
			_selected: {
				bg: `${r} !important`,
				border: `1px solid ${c}`,
				position: "relative",
				borderRadius: "6px",
				zIndex: "1",
				color: f,
				boxShadow: pr,
				_focusVisible: { boxShadow: `${mr}, ${pr}` }
			},
			_active: { bg: a },
			_focus: {
				bg: "transparent",
				border: "none"
			},
			_focusVisible: {
				boxShadow: mr,
				zIndex: "2",
				_disabled: { boxShadow: "none" }
			},
			_hover: { color: f },
			_disabled: {
				_selected: {
					borderColor: c,
					color: u,
					_hover: { color: u }
				},
				_hover: { color: l },
				color: l,
				opacity: 1
			}
		},
		tertiary: {
			...q,
			color: O,
			backgroundColor: "transparent",
			width: "fit-content",
			borderRadius: "none",
			px: 0,
			py: 0,
			height: "auto",
			minHeight: 0,
			_disabled: { opacity: .4 }
		},
		ghost: {
			...G,
			borderRadius: "20px",
			backgroundColor: r,
			color: H,
			border: "transparent",
			textTransform: "none",
			width: "fit-content",
			px: 6,
			py: 3,
			_hover: { bg: a },
			_active: { bg: c },
			_focus: {
				borderColor: "transparent",
				bg: r,
				boxShadow: `0 0 0 2px ${z}`
			},
			_disabled: { opacity: .4 }
		},
		ghost2: {
			...G,
			borderRadius: "8px",
			backgroundColor: r,
			color: u,
			border: "transparent",
			textTransform: "none",
			width: "fit-content",
			px: "12px",
			py: 0,
			_active: { bg: c },
			_focus: {
				borderColor: "transparent",
				bg: r,
				boxShadow: `0 0 0 2px ${z}`
			},
			_disabled: { opacity: .4 }
		},
		warning: {
			...G,
			borderRadius: "20px",
			backgroundColor: P,
			color: Q,
			textTransform: "none",
			width: "fit-content",
			px: 6,
			py: 3,
			_hover: { bg: F },
			_active: { bg: I },
			_focus: { boxShadow: `0 0 0 2px ${z}` },
			_disabled: { opacity: .4 }
		},
		warning2: {
			...G,
			borderRadius: "8px",
			backgroundColor: P,
			borderColor: F,
			color: Q,
			textTransform: "none",
			width: "fit-content",
			px: "12px",
			py: 0,
			boxShadow: "0px 2px 2px 0px rgba(15, 23, 42, 0.08), 0px -2px 2px 0px rgba(0, 0, 0, 0.04) inset",
			_hover: { bg: F },
			_active: { bg: I },
			_focus: { boxShadow: `0 0 0 2px ${z}` },
			_disabled: { opacity: .4 }
		},
		plain: {
			height: "auto",
			borderRadius: "none"
		},
		productBack: {
			borderColor: l,
			borderWidth: "1px",
			borderRadius: "24px",
			backgroundColor: a,
			fontWeight: 600,
			fontSize: "14px",
			width: "72px",
			height: "40px",
			color: "#013337",
			padding: "8px 24px",
			boxShadow: "0px 1px 0px rgba(51, 61, 74, 0.24), 0px 2px 6px rgba(51, 61, 74, 0.16)"
		},
		dateSkipper: {
			backgroundColor: "white",
			fontWeight: 600,
			fontSize: "14px",
			color: "turquoise.80",
			textTransform: "none",
			_hover: { bg: "gray.30" },
			_focus: {
				zIndex: 1,
				boxShadow: "0 0 0 3px rgb(66 153 225 / 60%)"
			}
		},
		selectBulk: {
			borderRadius: "6px",
			borderWidth: "1px",
			borderColor: "gray.40",
			height: "32px",
			width: "156px",
			fontFamily: "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif",
			fontStyle: "normal",
			fontWeight: 400,
			fontSize: "14px",
			lineHeight: "16px",
			backgroundColor: "transparent",
			pl: "12px",
			pr: 0,
			textAlign: "left",
			_hover: { backgroundColor: "gray.20" },
			_active: { backgroundColor: "gray.30" },
			_focus: {
				borderWidth: "1px",
				borderColor: "turquoise.60"
			}
		},
		icon: {
			borderColor: c,
			borderWidth: "1px",
			borderRadius: "8px",
			boxShadow: "0 2px 2px 0 rgba(15, 23, 42, 0.08), 0 -2px 2px 0 rgba(0, 0, 0, 0.04) inset",
			_hover: { bg: a }
		},
		"component-library-primary": {
			...K,
			background: H,
			minWidth: "initial",
			height: {
				base: "36px",
				md: "32px"
			},
			boxShadow: Z,
			px: "10px",
			py: "8px",
			color: r,
			borderRadius: "6px",
			_hover: {
				boxShadow: Z,
				background: B,
				_disabled: {
					background: l,
					boxShadow: Y
				}
			},
			_active: {
				boxShadow: Z,
				background: V,
				_disabled: {
					background: l,
					boxShadow: Y
				}
			},
			_focusVisible: {
				boxShadow: `0 0 0 2px ${E} `,
				_disabled: { boxShadow: "none" }
			},
			_disabled: {
				opacity: 1,
				background: l,
				boxShadow: Y
			}
		},
		"component-library-secondary": {
			...K,
			background: r,
			minWidth: "initial",
			height: {
				base: "36px",
				md: "32px"
			},
			boxShadow: X,
			border: `${c} 1px solid`,
			px: "10px",
			py: "8px",
			color: f,
			borderRadius: "6px",
			_hover: {
				boxShadow: X,
				background: i,
				border: `${l} 1px solid`,
				_disabled: {
					border: `${s} 1px solid`,
					background: r
				}
			},
			_active: {
				background: a,
				border: `${c} 1px solid`,
				boxShadow: Y
			},
			_focusVisible: {
				boxShadow: `0 0 0 2px ${E} `,
				_disabled: { boxShadow: "none" }
			},
			_disabled: {
				opacity: 1,
				border: `${s} 1px solid`,
				background: r,
				boxShadow: Y,
				color: l
			}
		},
		"component-library-ghost": {
			...K,
			color: O,
			padding: "8px",
			minWidth: "initial",
			height: {
				base: "36px",
				md: "32px"
			},
			borderRadius: "6px",
			background: {
				base: i,
				md: "transparent"
			},
			border: {
				base: `${c} 1px solid`,
				md: "transparent 1px solid"
			},
			boxShadow: {
				base: X,
				md: "none"
			},
			_hover: {
				background: i,
				border: `${c} 1px solid`,
				boxShadow: X,
				_disabled: {
					border: "transparent 1px solid",
					boxShadow: "none"
				}
			},
			_active: {
				background: a,
				border: `${c} 1px solid`,
				boxShadow: Y,
				_disabled: {
					border: "transparent 1px solid",
					boxShadow: "none"
				}
			},
			_focusVisible: {
				boxShadow: `0 0 0 2px ${E} `,
				_disabled: { boxShadow: "none" }
			},
			_disabled: {
				opacity: 1,
				color: l,
				background: "transparent",
				border: "transparent 1px solid",
				boxShadow: "none"
			}
		},
		"component-library-warning": {
			...K,
			background: N,
			color: r,
			padding: "8px",
			minWidth: "initial",
			height: "32px",
			borderRadius: "6px",
			border: `${N} 1px solid`,
			_hover: {
				background: P,
				border: `${P} 1px solid`,
				boxShadow: X,
				_disabled: {
					background: A,
					borderColor: A
				}
			},
			_active: {
				background: F,
				border: `${I} 1px solid`,
				boxShadow: Y
			},
			_disabled: {
				backgroundColor: A,
				opacity: 1,
				color: M,
				borderColor: A,
				boxShadow: Y
			}
		},
		"component-library-unstyled": {
			padding: "0px",
			minWidth: "initial",
			height: "initial",
			borderRadius: "0px"
		},
		"component-library-ai": {
			...K,
			background: D,
			minWidth: "initial",
			height: "32px",
			boxShadow: Z,
			px: "10px",
			py: "8px",
			color: r,
			borderRadius: "6px",
			_hover: {
				boxShadow: Z,
				background: O,
				_disabled: {
					background: l,
					boxShadow: Y
				}
			},
			_active: {
				boxShadow: Z,
				background: D,
				_disabled: {
					background: l,
					boxShadow: Y
				}
			},
			_disabled: {
				opacity: 1,
				background: l,
				boxShadow: Y
			}
		}
	},
	sizes: {
		sm: {
			borderRadius: "20px",
			px: 4,
			height: "36px",
			padding: "10px 12px"
		},
		xs: {
			borderRadius: "8px",
			px: 8,
			height: "32px"
		}
	}
}, gr = { baseStyle: {
	label: { display: "flex" },
	control: {
		bg: "white",
		_checked: {
			bg: "indigo.50",
			borderColor: "indigo.50",
			_hover: {
				bg: "indigo.50",
				borderColor: "indigo.50"
			}
		},
		_indeterminate: {
			bg: "indigo.50",
			borderColor: "indigo.50",
			_hover: {
				bg: "indigo.50",
				borderColor: "indigo.50"
			}
		},
		_disabled: {
			bg: "gray.200",
			borderColor: "gray.200"
		}
	}
} }, _r = { variants: { three: {
	...hr.variants?.three,
	width: "auto",
	textStyle: "",
	textTransform: "uppercase"
} } }, vr = {
	baseStyle: {
		borderStyle: "solid",
		borderColor: "blue.20",
		opacity: 1
	},
	variants: {
		subtle: { borderColor: $ },
		"component-library": { borderColor: s }
	}
}, yr = {
	baseStyle: { dialog: {
		maxW: "100%",
		maxWidth: "calc((100% - 104px)/2)",
		width: "100%",
		borderLeftRadius: "8px"
	} },
	variants: { sidebar: {
		closeButton: {
			top: 4,
			right: 6
		},
		body: {
			flex: 1,
			minHeight: 0,
			overflowY: "auto",
			p: 5,
			width: "100%"
		},
		header: {
			display: "flex",
			alignItems: "center",
			height: "64px",
			borderBottomWidth: "1px",
			borderColor: "gray.40",
			borderStyle: "solid",
			fontWeight: "600",
			fontSize: "16px",
			lineHeight: "24px",
			py: 5
		},
		footer: {
			display: "flex",
			flex: "0",
			bg: "white",
			alignItems: "center",
			borderBottomLeftRadius: "8px",
			height: "64px",
			borderTopWidth: "1px",
			borderColor: "gray.40",
			borderStyle: "solid",
			fontWeight: "600",
			fontSize: "16px",
			position: "sticky",
			bottom: 0,
			py: 3,
			px: 6
		}
	} },
	sizes: {
		md: { dialog: {
			maxW: "460px",
			maxWidth: "460px",
			width: "460px"
		} },
		lg: { dialog: {
			maxW: "480px",
			maxWidth: "480px",
			width: "480px"
		} },
		"depth-1": { dialog: {
			maxWidth: "calc((100% - 80px)/2)",
			maxHeight: "calc((100vh - 24px))",
			marginTop: "12px"
		} }
	}
}, br = { baseStyle: {
	fontSize: "14px",
	fontWeight: 600,
	mb: 0
} }, xr = { variants: { clear: {
	backgroundColor: "transparent",
	_hover: { backgroundColor: "transparent" }
} } }, { Primary13Regular: Sr, RedRed60: Cr } = re, wr = {
	...Sr,
	borderRadius: "6px",
	backgroundColor: r,
	borderStyle: "solid",
	borderWidth: "1px",
	borderColor: $,
	color: m,
	boxShadow: `0px 2px 4px 0px ${m}14, 0px -2px 2px 0px #0000000A inset`,
	py: 3,
	px: 3,
	height: "auto",
	_invalid: {
		borderColor: Cr,
		boxShadow: ir
	},
	_focus: {
		borderColor: D,
		boxShadow: rr
	},
	_placeholder: {
		fontWeight: 400,
		color: l
	},
	_disabled: { opacity: .4 }
}, Tr = {
	...Sr,
	backgroundColor: r,
	color: m,
	py: 3,
	px: 3,
	height: "auto",
	_placeholder: {
		fontWeight: 400,
		color: l
	},
	_disabled: { opacity: .4 },
	outline: "none"
}, Er = {
	...Sr,
	width: "100%",
	border: `1px solid ${c}`,
	boxShadow: `0px 1px 2px 0px ${m}0a`,
	backgroundColor: r,
	_hover: {
		border: `1px solid ${l}`,
		boxShadow: "0px 0px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 2px 0px rgba(0, 0, 0, 0.07)"
	},
	_focus: {
		outline: `2px solid ${D}`,
		outlineOffset: "-1px",
		boxShadow: `0px 1px 3px 0px ${m}0f`
	},
	_invalid: { border: `1px solid ${F}` }
}, Dr = {
	baseStyle: { field: {} },
	variants: {
		"sequence-form": {
			field: { ...wr },
			addon: {
				color: "green",
				bg: "blue"
			}
		},
		"input-in-group": {
			field: { ...Tr },
			addon: {
				color: d,
				bg: r,
				px: 3,
				svg: {
					width: "16px",
					height: "16px"
				}
			},
			element: {
				height: "100%",
				left: 2,
				color: l
			}
		},
		"input-in-group-2": {
			field: { ...Tr },
			addon: {
				color: d,
				bg: r,
				px: 3,
				svg: {
					width: "16px",
					height: "16px"
				}
			},
			element: {
				height: "100%",
				left: 2,
				color: f
			}
		},
		plain: {
			border: "none",
			outline: "none"
		},
		headline: { field: {
			borderRadius: 0,
			border: "none",
			color: "gray.70",
			fontWeight: 600,
			fontSize: "20px",
			lineHeight: "24px",
			px: 2
		} },
		"table-cell": {
			field: {
				padding: 4,
				borderRadius: 0,
				height: "56px",
				textAlign: "right"
			},
			addon: {
				mt: "0px",
				paddingLeft: "2px",
				lineHeight: "19px",
				height: "56px"
			}
		},
		formInput2: { field: { ...Er } },
		"component-library": { field: {
			...q,
			outline: "none",
			height: "32px",
			border: `${c} 1px solid`,
			paddingLeft: "12px",
			paddingRight: "12px",
			color: p,
			backgroundColor: r,
			boxShadow: Y,
			borderRadius: "6px",
			_placeholder: { color: l },
			_focus: { border: `${D} 1px solid` },
			_disabled: {
				opacity: 1,
				boxShadow: "none",
				border: `${s} 1px solid`,
				color: l,
				background: a
			}
		} }
	},
	sizes: {
		md: { field: {
			height: "40px",
			borderRadius: "6px"
		} },
		sm: { field: {
			height: "36px",
			borderRadius: "8px"
		} }
	},
	defaultProps: { size: "md" }
}, Or = { baseStyle: {
	color: "inherit",
	textDecoration: "none",
	_hover: { textDecoration: "none" }
} }, kr = { variants: { "template-modal": { item: {
	"&::marker": {
		color: "gray.80",
		fontSize: "14px",
		lineHeight: "24px",
		fontWeight: 600
	},
	flexDirection: "column",
	spacing: "4px"
} } } }, Ar = {
	baseStyle: {
		button: {
			...G,
			borderRadius: "6px",
			_focus: { boxShadow: "0 0 0 3px rgba(66, 153, 225, 0.6)" }
		},
		list: {
			borderRadius: "6px",
			padding: "0",
			zIndex: 1
		},
		item: {
			borderRadius: "6px",
			_hover: { borderRadius: "6px" },
			_focus: { backgroundColor: o },
			_active: { backgroundColor: o }
		}
	},
	variants: {
		select: { item: {
			px: "16px",
			py: "20px"
		} },
		kebab: { button: {
			borderRadius: "50%",
			width: "24px",
			height: "24px",
			minWidth: "24px",
			maxWidth: "24px",
			maxHeight: "24px",
			backgroundColor: "transparent",
			_hover: { backgroundColor: $ },
			_active: { backgroundColor: "gray.40" }
		} },
		"component-library": {
			list: {
				background: r,
				borderRadius: "8px",
				border: `${c} 1px solid`,
				boxShadow: "0px 8px 16px 0px rgba(0, 0, 0, 0.08)",
				padding: "4px"
			},
			button: {
				...G,
				borderRadius: "6px",
				_focus: {
					outline: `2px solid ${D}`,
					outlineOffset: 0
				}
			},
			item: {
				...q,
				padding: "8px",
				color: f,
				transition: "none",
				marginBottom: 1,
				_hover: { backgroundColor: o },
				_active: {
					backgroundColor: `${D} !important`,
					color: r
				},
				_disabled: { _active: {
					backgroundColor: `${o} !important`,
					color: f
				} }
			},
			divider: {
				borderColor: s,
				position: "relative",
				left: "-4px",
				width: "calc(100% + 8px)",
				my: "4px"
			}
		}
	}
}, jr = {
	baseStyle: {
		header: {
			textStyle: "header1",
			fontWeight: 600,
			fontSize: "24px",
			lineHeight: "29px",
			flex: 1
		},
		dialog: {
			margin: "32px",
			borderRadius: "24px"
		},
		footer: {
			borderColor: $,
			borderTopWidth: "1px",
			height: "72px"
		}
	},
	sizes: { exports: { dialog: {
		width: "100%",
		maxWidth: "900px",
		height: "100%",
		maxHeight: "524px"
	} } },
	variants: {
		v2: {
			dialog: {
				minWidth: "490px",
				padding: 0,
				borderRadius: "8px",
				boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.08)"
			},
			overlay: { backgroundColor: "rgba(0, 0, 0, 0.24)" },
			header: {
				borderBottom: `1px solid ${s}`,
				...W
			},
			footer: {
				height: "auto",
				padding: 3,
				gap: 2,
				justifyContent: "flex-end"
			}
		},
		outsideScroll: { dialogContainer: { width: "100%" } }
	}
}, Mr = { variants: {
	dateInput: {
		popper: { width: "auto" },
		content: { border: "none" },
		body: {
			borderRadius: "8px",
			boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.16)",
			p: 4,
			bg: "white"
		}
	},
	dateRange: {
		popper: { width: "fit-content" },
		content: {
			border: "none",
			width: "fit-content"
		},
		body: {
			borderRadius: "8px",
			boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.16)",
			p: 4,
			bg: "white",
			width: "fit-content"
		}
	},
	fieldInfo: {
		header: {
			borderBottomWidth: 0,
			...K,
			lineHeight: "20px",
			pt: 5,
			px: 4,
			pb: 2
		},
		body: {
			...q,
			lineHeight: "20px",
			pt: 0,
			px: 4,
			pb: 5
		},
		content: {
			borderRadius: "8px",
			maxWidth: "300px"
		}
	},
	info: {
		header: { ...q },
		body: {
			...q,
			lineHeight: "20px",
			padding: 3,
			boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.08)"
		},
		content: { width: "auto" }
	},
	unstyled: { content: {
		borderRadius: "0px",
		border: "none",
		background: "transparent",
		width: "fit-content"
	} }
} }, Nr = { baseStyle: {
	filledTrack: { bg: Gt },
	track: { bg: "gray.50" }
} }, Pr = { variants: { descriptionGroup: { control: {
	borderRadius: "14px",
	_checked: {
		bg: "indigo.50",
		color: "white",
		borderColor: "indigo.50"
	}
} } } }, Fr = { variants: { "sequence-form": { field: { ...wr } } } }, Ir = { variants: {
	one: { container: {
		borderRight: "1px solid",
		borderColor: $
	} },
	two: { container: {
		px: 5,
		py: 4,
		border: "1px solid",
		borderColor: "blue.20",
		rounded: "sm",
		backgroundColor: "white",
		height: "5.75rem",
		borderRadius: "4px"
	} }
} }, Lr = {
	defaultProps: {
		variant: "default",
		size: "sm"
	},
	variants: {
		activeInactive: {
			container: { bg: "none" },
			track: {
				bg: l,
				_checked: { bg: g }
			}
		},
		warning: {
			container: { bg: "none" },
			track: {
				bg: l,
				_checked: { bg: P }
			}
		},
		default: {
			track: {
				bg: l,
				_focusVisible: {
					boxShadow: `0 0 0 2px ${E}`,
					_disabled: { boxShadow: "none" }
				},
				_checked: { bg: D }
			},
			thumb: {
				bgGradient: "linear-gradient(180deg, #FFF 46.88%, #F0F6FD 100%)",
				boxShadow: "0px 2px 4px 0px rgba(15, 23, 42, 0.04)"
			}
		}
	},
	sizes: {
		sm: {
			track: { width: "24px" },
			thumb: { _checked: { transform: "translateX(12px)" } }
		},
		md: {
			track: { width: "32px" },
			thumb: { _checked: { transform: "translateX(16px)" } }
		}
	}
}, Rr = { variants: {
	virtual: {
		table: {
			backgroundColor: "white",
			borderCollapse: "separate",
			borderSpacing: 0
		},
		th: {
			p: 0,
			whiteSpace: "nowrap",
			fontWeight: 600,
			fontSize: "13px",
			textTransform: "none",
			color: "gray.80",
			backgroundColor: o,
			letterSpacing: "none"
		},
		tr: {
			_hover: { backgroundColor: "gray.10" },
			_notLast: { td: {
				borderBottomWidth: "1px",
				borderBottomStyle: "solid",
				borderBottomColor: $
			} }
		},
		td: {
			overflow: "hidden",
			px: 4,
			py: 4,
			lineHeight: "24px",
			fontWeight: 400,
			fontSize: "13px",
			color: "gray.80",
			bg: "transaprent"
		},
		thead: {
			top: 0,
			position: "sticky",
			backgroundColor: "white",
			zIndex: 3
		}
	},
	direct: {
		table: {
			borderCollapse: "separate",
			borderSpacing: 0,
			borderBottomWidth: "1px",
			borderBottomStyle: "solid",
			borderBottomColor: $
		},
		th: {
			p: 0,
			whiteSpace: "nowrap",
			fontWeight: 600,
			fontSize: "13px",
			textTransform: "none",
			color: "gray.80",
			backgroundColor: o,
			_notLast: { borderRight: "1px solid white" }
		},
		tr: { _notLast: { td: {
			borderBottomWidth: "1px",
			borderBottomStyle: "solid",
			borderBottomColor: $
		} } },
		td: {
			p: 0,
			_notLast: { borderRight: "1px solid white" }
		},
		thead: {
			top: 0,
			position: "sticky",
			backgroundColor: "white"
		}
	},
	lineItemGroup: {
		table: { tableLayout: "fixed" },
		th: { padding: 0 },
		td: { padding: 0 }
	},
	simple: {
		table: { tableLayout: "fixed" },
		th: {
			px: 0,
			py: 2
		},
		td: {
			px: 0,
			py: 2,
			border: "none"
		}
	},
	v2: {
		table: { tableLayout: "fixed" },
		thead: {
			height: "36px",
			tr: { borderBottom: `1px solid ${s}` },
			th: {
				...K,
				textTransform: "none",
				color: u,
				backgroundColor: a,
				padding: "10px 12px",
				letterSpacing: "0.12px"
			}
		},
		tfoot: {
			height: "36px",
			tr: { borderTop: `1px solid ${s}` },
			td: {
				fontSize: q.fontSize,
				lineHeight: q.lineHeight,
				fontFamily: q.fontFamily,
				color: d,
				textTransform: "none",
				backgroundColor: r,
				padding: "10px 12px",
				letterSpacing: "0.12px"
			}
		},
		tbody: {
			color: f,
			tr: {
				borderBottom: `1px solid ${s}`,
				cursor: "pointer",
				_hover: { backgroundColor: a },
				_last: { borderBottom: "none" }
			},
			td: {
				height: "36px",
				...q,
				padding: "10px 12px",
				whiteSpace: "nowrap",
				overflow: "hidden",
				textOverflow: "ellipsis"
			}
		}
	},
	"v2-without-hover": {
		table: { tableLayout: "fixed" },
		thead: {
			tr: { borderBottom: `1px solid ${s}` },
			th: {
				...K,
				textTransform: "none",
				color: d,
				padding: "10px 12px",
				letterSpacing: "0.12px",
				backgroundColor: a
			}
		},
		tfoot: {
			height: "36px",
			tr: { borderTop: `1px solid ${s}` },
			td: {
				fontSize: q.fontSize,
				lineHeight: q.lineHeight,
				fontFamily: q.fontFamily,
				color: d,
				textTransform: "none",
				backgroundColor: r,
				padding: "10px 12px",
				letterSpacing: "0.12px"
			}
		},
		tbody: {
			color: d,
			tr: {
				borderBottom: `1px solid ${s}`,
				_last: { borderBottom: "none" }
			},
			td: {
				height: "36px",
				...q,
				padding: "6px 12px",
				whiteSpace: "nowrap",
				overflow: "hidden"
			}
		}
	},
	totals: {
		table: { tableLayout: "auto" },
		th: {
			px: 0,
			py: 2
		},
		td: {
			px: 0,
			py: 1,
			border: "none"
		}
	}
} }, zr = { variants: {
	line: {
		tablist: { borderBottomWidth: "1px" },
		tab: {
			height: "50px",
			textStyle: "sidebarRegular",
			borderBottomWidth: "4px",
			borderColor: "transparent",
			_active: { background: "transparent" },
			_selected: {
				color: "blue.300",
				textStyle: "sidebarBold",
				borderColor: "green.100"
			},
			_first: {
				borderTopLeftRadius: "8px",
				borderBottomLeftRadius: "8px"
			},
			_last: {
				borderTopRightRadius: "8px",
				borderBottomRightRadius: "8px"
			}
		},
		tabpanel: { padding: 5 }
	},
	"soft-rounded": { tab: {
		color: "blue.40",
		py: 1,
		fontWeight: 400,
		fontSize: "14px",
		lineHeight: "24px",
		textTransform: "uppercase",
		_selected: {
			backgroundColor: "green.80",
			fontWeight: 600,
			color: "blue.200"
		}
	} },
	"new-rounded": {
		tablist: {
			borderBottomWidth: "1px",
			bg: "gray.30",
			height: "48px",
			borderRadius: "24px",
			padding: "8 24px",
			boxShadow: "inset 0px 1px 2px rgba(31, 45, 96, 0.25), inset 0px 2px 6px rgba(28, 68, 104, 0.06)"
		},
		tab: {
			color: "gray.70",
			width: "115px",
			py: 1,
			fontSize: "14px",
			lineHeight: "24px",
			rounded: "full",
			margin: "4px",
			fontWeight: 600,
			_selected: {
				backgroundColor: "white",
				color: "gray.100",
				borderColor: $,
				borderWidth: "1px",
				borderStyle: "solid",
				boxShadow: "0px 2px 6px 0px #333D4A29, 0px 1px 0px 0px #333D4A3D"
			},
			_hover: { backgroundColor: o }
		}
	},
	"select-tabs": {
		tablist: {
			backgroundColor: "white",
			borderWidth: "1px",
			borderColor: "gray.40",
			borderRadius: "8px"
		},
		tab: {
			color: "gray.100",
			borderRightColor: "gray.40",
			borderRightWidth: "1px",
			padding: "8px 16px",
			_active: {
				background: "turquoise.80",
				color: "white",
				_first: {
					borderTopLeftRadius: "8px",
					borderBottomLeftRadius: "8px"
				},
				_last: {
					borderTopRightRadius: "8px",
					borderBottomRightRadius: "8px"
				}
			},
			_selected: {
				color: "white",
				background: "turquoise.80",
				borderColor: "gray.40",
				_first: {
					borderTopLeftRadius: "8px",
					borderBottomLeftRadius: "8px"
				},
				_last: {
					borderTopRightRadius: "8px",
					borderBottomRightRadius: "8px"
				},
				icon: { color: "white" }
			}
		}
	},
	"customer-portal": {
		tablist: { height: "40px" },
		tab: {
			padding: "12px 8px",
			fontSize: "14px",
			lineHeight: "16px",
			borderBottomColor: $,
			borderBottomWidth: "1px",
			fontWeight: 400,
			_selected: {
				borderBottomColor: "gray.100",
				borderBottomWidth: "1px",
				borderStyle: "solid",
				fontWeight: 600
			}
		}
	},
	"modal-tabs": {
		tablist: {
			height: "48px",
			px: "28px"
		},
		tab: {
			padding: "12px 16px",
			fontSize: "14px",
			lineHeight: "16px",
			fontWeight: 400,
			_selected: {
				borderBottomColor: "gray.100",
				borderBottomWidth: "1.5px",
				borderStyle: "solid",
				fontWeight: 600
			},
			_hover: { color: "gray.100" }
		}
	}
} }, Br = {
	default: {
		fontSize: "14px",
		fontWeight: 400,
		lineHeight: "16px",
		color: "gray.100"
	},
	bold: {
		fontSize: "14px",
		fontWeight: 600,
		lineHeight: "16px",
		color: "gray.100"
	},
	boldLarge: {
		fontSize: "16px",
		fontWeight: 600,
		lineHeight: "24px",
		color: "gray.100"
	},
	header1: {
		fontWeight: 600,
		fontSize: "40px",
		lineHeight: "48px"
	},
	header2: {
		fontWeight: 400,
		fontSize: "28px",
		lineHeight: "34px"
	},
	header3: {
		fontWeight: 300,
		fontSize: "20px",
		lineHeight: "30px"
	},
	mainText: {
		fontWeight: 600,
		fontSize: "24px",
		lineHeight: "32px"
	},
	sidebarBold: {
		fontWeight: 600,
		fontSize: "16px",
		lineHeight: "20px",
		color: "blue.200"
	},
	sidebarRegular: {
		fontWeight: 400,
		fontSize: "14px",
		lineHeight: "16px",
		color: "gray.100"
	},
	sidebarSubNav: {
		color: "gray.100",
		fontWeight: "400",
		fontSize: "14px",
		lineHeight: "16px"
	},
	tableTextBold: {
		fontWeight: 600,
		fontSize: "13px",
		lineHeight: "20px"
	},
	tableTextRegular: {
		fontWeight: 400,
		fontSize: "13px",
		lineHeight: "20px"
	},
	ctaLarge: {
		fontWeight: 600,
		fontSize: "14px",
		lineHeight: "24px"
	},
	ctaSmall: {
		fontWeight: 600,
		fontSize: "12px",
		lineHeight: "24px"
	},
	feature: {
		fontWeight: 400,
		fontSize: "14px",
		lineHeight: "20px"
	},
	formTitle: {
		fontSize: "32px",
		fontWeight: 600
	},
	previewTitle: {
		fontSize: "32px",
		fontWeight: 600,
		lineHeight: "80px"
	},
	previewLabel: {
		fontSize: "14px",
		fontWeight: 600
	},
	previewText: {
		fontSize: "14px",
		fontWeight: 400
	},
	formLabel: {
		fontSize: "14px",
		fontWeight: 600,
		lineHeight: "16px",
		color: "gray.100"
	},
	billingScheduleFormLabel: {
		fontSize: "18px",
		fontWeight: 600,
		lineHeight: "20px",
		color: "gray.100"
	},
	formSubTitle: {
		fontSize: "16px",
		fontWeight: 600,
		lineHeight: "20px",
		color: "gray.100"
	},
	planTotal: {
		fontSize: "40px",
		lineHeight: "48px",
		color: "gray.100"
	},
	addProductButton: {
		fontWeight: "600",
		fontSize: "14px",
		lineHeight: "24px",
		color: "turquiose.60"
	},
	titleBar: {
		fontWeight: "600",
		fontSize: "16px",
		color: "gray.100"
	},
	hint: {
		color: "gray.60",
		fontSize: "13px",
		fontWeight: "400"
	},
	sectionHeader: {
		fontSize: "18px",
		fontWeight: "600",
		color: "gray.100"
	},
	productDescription: {
		fontSize: "12px",
		fontWeight: 400,
		lineHeight: "14px"
	},
	infoText: {
		fontWeight: 400,
		fontSize: "14px",
		lineHeight: "20px",
		color: "gray.70"
	},
	infoTextBold: {
		fontWeight: 600,
		fontSize: "14px",
		lineHeight: "20px",
		color: "gray.70"
	},
	taxInfoText: {
		fontSize: "16px",
		fontWeight: 400,
		lineHeight: "24px",
		color: "gray.100"
	},
	taxRateProductHeading: {
		fontWeight: 600,
		fontSize: "14px",
		lineHeight: "17px"
	},
	note: {
		color: "gray.60",
		fontSize: "12px",
		fontWeight: "400"
	},
	tableHeader: {
		fontWeight: 600,
		fontSize: "13px",
		lineHeight: "17px",
		color: "gray.60"
	},
	invoiceBottomContent: {
		fontWeight: 400,
		fontSize: "20px",
		color: "gray.70"
	},
	invoicePaymentTitle: {
		fontWeight: 400,
		fontSize: "12px",
		color: "gray.70"
	},
	invoicePaymentContent: {
		fontWeight: 600,
		fontSize: "12px",
		color: "gray.70",
		textAlign: "right",
		width: "100%"
	},
	toastTitle: {
		fontWeight: 600,
		fontSize: "16px",
		lineHeight: "24px",
		color: "gray.90"
	},
	toastDescription: {
		fontWeight: 400,
		fontSize: "16px",
		lineHeight: "24px",
		color: "gray.90"
	},
	toastLink: {
		fontWeight: 400,
		fontSize: "16px",
		lineHeight: "24px",
		color: "indigo.60"
	},
	accordionButtonTitle: {
		color: "gray.100",
		fontWeight: 600,
		fontSize: "16px",
		lineHeight: "24px"
	},
	accordionBodyTitle: {
		color: "gray.100",
		fontWeight: 600,
		fontSize: "24px",
		lineHeight: "28px"
	},
	accordionBodyDescription: {
		fontSize: "16px",
		lineHeight: "24px"
	},
	eyebrow: {
		...U,
		color: u,
		textTransform: "uppercase"
	},
	columnHeading: {
		color: u,
		fontWeight: 600,
		fontSize: "13px",
		lineHeight: "16px"
	},
	pageTitle: {
		color: m,
		fontWeight: 600,
		fontSize: "20px",
		lineHeight: "24px"
	},
	emptyStateTitle: {
		color: "gray.100",
		fontWeight: 600,
		fontSize: "20px",
		lineHeight: "24px"
	},
	emptyStateDescription: {
		color: "gray.100",
		fontWeight: 400,
		fontSize: "16px",
		lineHeight: "24px"
	},
	errorPageTitle: {
		fontWeight: 600,
		fontSize: "40px",
		lineHeight: "64px"
	},
	orderedList: {
		fontWeight: 400,
		fontSize: "14px",
		lineHeight: "24px",
		color: "gray.80"
	},
	accordionTitle: {
		fontSize: "14px",
		fontWeight: 600,
		lineHeight: "16px",
		color: "gray.80"
	},
	accordionDescription: {
		fontSize: "14px",
		fontWeight: 400,
		lineHeight: "16px",
		color: "gray.80"
	},
	link: {
		fontSize: "14px",
		color: "indigo.50"
	},
	widgetTitle: {
		fontWeight: 600,
		fontSize: "16px",
		lineHeight: "24px",
		color: "gray.100"
	},
	lato12Regular: U,
	lato12Bold: gt,
	lato13Regular: q,
	lato13Bold: K,
	lato14Regular: q,
	lato14Bold: G,
	lato16Regular: jt,
	lato16Bold: W,
	lato20Regular: Ot,
	lato20Bold: Dt,
	lato24Regular: Et,
	lato24Bold: Tt,
	lato28Regular: wt,
	lato28Bold: Ct,
	lato32Regular: St,
	lato32Bold: xt,
	lato40Regular: bt,
	lato40Bold: yt
}, Vr = (e) => typeof e == "string" && e in Br, Hr = { baseStyle: ({ textStyle: e }) => Br[Vr(e) ? e : "default"] }, Ur = { variants: { "sequence-form": { ...wr } } }, Wr = ee({
	colors: {
		main: "#2E2C34",
		...ur
	},
	fonts: {
		body: J,
		heading: J
	},
	textStyles: Br,
	components: {
		Accordion: fr,
		Button: hr,
		Checkbox: gr,
		CloseButton: _r,
		Divider: vr,
		Drawer: yr,
		FormLabel: br,
		IconButton: xr,
		Input: Dr,
		Link: Or,
		List: kr,
		Menu: Ar,
		Modal: jr,
		Popover: Mr,
		Progress: Nr,
		Radio: Pr,
		Select: Fr,
		Stat: Ir,
		Switch: Lr,
		Table: Rr,
		Tabs: zr,
		Text: Hr,
		Textarea: Ur
	},
	shadows: { outline: "none" }
}), Gr = (ee) => /* @__PURE__ */ n(e, {
	theme: Wr,
	portalZIndex: 40,
	children: ee.children
});
//#endregion
export { fe as $, A as $n, st as $r, $t, Cn as A, xt as An, An as Ar, Re as At, Bt as B, B as Bn, _ as Br, ce as Bt, gn as C, Ot as Cn, Yn as Cr, Pe as Ct, fn as D, wt as Dn, Dn as Dr, O as Dt, pn as E, Tt as En, En as Er, D as Et, In as F, ft as Fn, Pn as Fr, Zn as Ft, ve as G, Ve as Gn, S as Gr, er as Gt, he as H, H as Hn, y as Hr, ue as Ht, Ln as I, pt as In, Tn as Ir, ie as It, xe as J, We as Jn, T as Jr, an as Jt, ye as K, He as Kn, C as Kr, $n as Kt, Rn as L, mt as Ln, Fn as Lr, ae as Lt, yn as M, yt as Mn, jn as Mr, Ft as Mt, vn as N, Te as Nn, Mn as Nr, It as Nt, hn as O, Ct as On, On as Or, Ie as Ot, xn as P, dt as Pn, Nn as Pr, Lt as Pt, me as Q, k as Qn, ot as Qr, en as Qt, zt as R, ht as Rn, Qn as Rr, oe as Rt, ln as S, kt as Sn, Jn as Sr, Ne as St, mn as T, Et as Tn, Xn as Tr, E as Tt, ge as U, ze as Un, b as Ur, de as Ut, J as V, V as Vn, v as Vr, le as Vt, _e as W, Be as Wn, x as Wr, tr as Wt, Ce as X, Ke as Xn, it as Xr, Qt as Xt, Se as Y, Ge as Yn, rt as Yr, tn as Yt, we as Z, qe as Zn, at as Zr, Q as Zt, un as _, Mt as _n, Un as _r, u as _t, or as a, Qe as an, I as ar, ke as at, sn as b, W as bn, Kn as br, p as bt, sr as c, tt as cn, Vt as cr, je as ct, Xt as d, gt as dn, X as dr, a as dt, ct as ei, nn as en, j as er, pe as et, Zt as f, vt as fn, Z as fr, m as ft, Yt as g, Nt as gn, Hn as gr, l as gt, Kt as h, K as hn, Vn as hr, c as ht, rr as i, ne as ii, Ze as in, F as ir, Oe as it, bn as j, bt as jn, wn as jr, Pt as jt, Sn as k, St as kn, kn as kr, Le as kt, lr as l, nt as ln, Wt as lr, Me as lt, qt as m, q as mn, Bn as mr, s as mt, $ as n, ut as ni, Ye as nn, N as nr, h as nt, cr as o, $e as on, L as or, g as ot, Jt as p, _t as pn, Y as pr, o as pt, be as q, Ue as qn, w as qr, rn as qt, ir as r, R as ri, Xe as rn, P as rr, De as rt, ar as s, et as sn, Ht as sr, Ae as st, Gr as t, lt as ti, Je as tn, M as tr, Ee as tt, Gt as u, U as un, Ut as ur, i as ut, dn as v, G as vn, Wn as vr, d as vt, _n as w, Dt as wn, zn as wr, Fe as wt, on as x, At as xn, qn as xr, r as xt, cn as y, jt as yn, Gn as yr, f as yt, Rt as z, z as zn, nr as zr, se as zt };

//# sourceMappingURL=theme-CQlMItXo.js.map